import Device from './helpers/Device';
import HeaderMenu from './components/HeaderMenu';
import AccordionMenu from './components/AccordionMenu';
import MainVisual from './components/MainVisual';
import ProjectRenderer from './components/ProjectRenderer';
import TextTruncate from './components/TextTruncate';
import LanguageSwitcher from './components/LanguageSwitcher';
import GoogleMap from "./components/GoogleMap";

$(document).ready(() => {
  //new HeaderMenu();

  if (Device.isPc() && !Device.isTablet()) {
    new MainVisual();
  } else if (Device.isMobile()) {
    new AccordionMenu();
  }

  if ($('#js-gmap').length) {
    new GoogleMap();
  }

  new ProjectRenderer();
  new TextTruncate();
  new LanguageSwitcher();
});
